import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  customer: Yup.object().nullable().required('Consumer Name is Required'),
  customerPONumber: Yup.string().nullable(),
  // salesOrderTicketId: Yup.number().nullable().positive().integer(),
  salesOrderLocationId: Yup.string().nullable(),
  orderSalesDetails: Yup.object().shape({
    effectiveDate: Yup.date().nullable(),
    expirationDate: Yup.date()
      .nullable()
      .when('effectiveDate', (effectiveDate, schema) => {
        if (effectiveDate) {
          return Yup.date()
            .min(effectiveDate, 'Expiration Date can not earlier than Effective Date')
            .typeError('Expiration Date is required')
        }
        return schema
      }),
    packageType: Yup.string().nullable(),
    fairOnBoard: Yup.string().nullable(),
    departingYard: Yup.string().nullable(),
    invoiceWeights: Yup.string().nullable(),
  }),
  freightDestination: Yup.object()
    .nullable()
    .shape({
      customerName: Yup.string().nullable().required('Freight customer is required'),
      customerId: Yup.string().nullable(),
      locationName: Yup.string().nullable(),
      locationId: Yup.string().nullable(),
      address: Yup.string().nullable().required('Address is required'),
      city: Yup.string().nullable().required('City is required'),
      state: Yup.string().nullable(),
      zip: Yup.string().nullable(),
    }),
  currency: Yup.string().nullable(),
  paymentTermId: Yup.string().nullable(),
  paymentMethod: Yup.string().nullable(),
  paymentOptions: Yup.string().nullable(),
  customForeignExchangeRateEnabled: Yup.boolean(),
  foreignExchangeRate: Yup.mixed()
    .nullable()
    .when('customForeignExchangeRateEnabled', {
      is: true,
      then: Yup.number().required('Exchange rate is required when using custom rate'),
    }),
  notes: Yup.string().nullable(),
  docs: Yup.array().of(
    Yup.object().shape({
      createdAt: Yup.string().nullable(),
      name: Yup.string().nullable(),
      url: Yup.string().nullable(),
      uuid: Yup.string().nullable(),
    }),
  ),
  uploadcareGroupId: Yup.string().nullable(),
  isExport: Yup.bool().nullable(),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
